import Base from './base.js';

/** 云盘 - 自定义商品 */ 
export default class YunDisk extends Base {
  buyUrl = 'https://ecs-buy.aliyun.com/disk/#/cloudDisk/';

  match(code) {
    return code === 'yundisk';
  }

  // getBuyConfig() {
  //   let commodityValue = this.commodityValue;

  //   //兼容空的情况
  //   if(commodityValue && commodityValue.region) {
  //     this.buyUrl = BuyUrl + commodityValue.region;

  //     return {
  //       zoneId: commodityValue.zoneId,
  //       dataDisk: JSON.stringify({
  //         category: commodityValue.category,
  //         size: commodityValue.size
  //       })
  //     };
  //   }

  //   return {};
    
  // }

  getBuyUrl() {
    return this.execute(() => {
      let buyUrl = '';
      let commodityValue = this.commodityValue;

      //兼容空的情况
      if(commodityValue && commodityValue.region) {
        buyUrl = this.buyUrl + commodityValue.region;

        buyUrl += '?zoneId=' + commodityValue.zoneId;

        buyUrl += '&dataDisk=' + encodeURI(JSON.stringify([{
          category: commodityValue.category,
          size: commodityValue.size
        }]));
      }
      return buyUrl;

    });
  }

}


// WEBPACK FOOTER //
// ./lib/services/product/yundisk.js